import BaseModel from "./BaseModel";

// import {
//   canEdit,
//   canView,
//   canDelete,
//   isClosed,
//   isCompliant,
//   simpleStatus,
//   canOpen,
//   canClose,
//   isOwner,
//   isApproved,
//   canUploadProgramme,
//   isEvaluated
// } from "@/helpers/Certification";

class ReportModel extends BaseModel {
  id = 0;
  parent = 0;
  report = 0;
  year = 0;
  status = "";
  type = "";
  organization = "";

  hcpIndAmount = 0;
  hcpIndRegCost = 0;
  hcpIndTravelCost = 0;
  hcpIndBasicSalary = 0;
  hcpIndAdditionalSalary = 0;

  hcpGrpAmount = 0;
  hcpGrpRegCost = 0;
  hcpGrpTravelCost = 0;
  hcpGrpBasicSalary = 0;
  hcpGrpAdditionalSalary = 0;

  hcoIndAmount = 0;
  hcoIndDonation = 0;
  hcoIndRegCost = 0;
  hcoIndTravelCost = 0;
  hcoIndSponsorship = 0;
  hcoIndBasicSalary = 0;
  hcoIndAdditionalSalary = 0;

  hcoGrpAmount = 0;
  hcoGrpDonation = 0;
  hcoGrpRegCost = 0;
  hcoGrpTravelCost = 0;
  hcoGrpSponsorship = 0;
  hcoGrpBasicSalary = 0;
  hcoGrpAdditionalSalary = 0;

  rndCost = 0;

  reportUrl = "";
  organizationReportUrl = "";
  organizationComments = "";
  approverComments = "";

  extended: object = {};
  createdBy = 0;
  createdOn: Date | null = null;
  approved = false;
  approvedBy = 0;
  approvedOn: Date | null = null;
  published = false;
  publishedBy = 0;
  publishedOn: Date | null = null;
  deleted = 0;
  deletedBy = 0;
  deletedOn: Date | null = null;

  constructor(options?: object) {
    super(options);
    this.setData(options);
  }

  get hcpAmount() {
    return this.sumColsByNames(["hcpIndAmount", "hcpGrpAmount"]);
  }

  get hcpIndEventTotal() {
    return this.sumColsByNames(["hcpIndRegCost", "hcpIndTravelCost"]);
  }

  get hcpGrpEventTotal() {
    return this.sumColsByNames(["hcpGrpRegCost", "hcpGrpTravelCost"]);
  }

  get hcpRegTotal() {
    return this.sumColsByNames(["hcpIndRegCost", "hcpGrpRegCost"]);
  }

  get hcpTravelTotal() {
    return this.sumColsByNames(["hcpIndTravelCost", "hcpGrpTravelCost"]);
  }

  get hcpEventTotal() {
    return this.sumColsByNames(["hcpRegTotal", "hcpTravelTotal"]);
  }

  get hcpIndSalaryTotal() {
    return this.sumColsByNames(["hcpIndBasicSalary", "hcpIndAdditionalSalary"]);
  }

  get hcpGrpSalaryTotal() {
    return this.sumColsByNames(["hcpGrpBasicSalary", "hcpGrpAdditionalSalary"]);
  }

  get hcpBasicSalaryTotal() {
    return this.sumColsByNames(["hcpIndBasicSalary", "hcpGrpBasicSalary"]);
  }

  get hcpAdditionalSalaryTotal() {
    return this.sumColsByNames([
      "hcpIndAdditionalSalary",
      "hcpGrpAdditionalSalary"
    ]);
  }

  get hcpSalaryTotal() {
    return this.sumColsByNames([
      "hcpBasicSalaryTotal",
      "hcpAdditionalSalaryTotal"
    ]);
  }

  get hcpIndTotal() {
    return this.sumColsByNames(["hcpIndEventTotal", "hcpIndSalaryTotal"]);
  }

  get hcpGrpTotal() {
    return this.sumColsByNames(["hcpGrpEventTotal", "hcpGrpSalaryTotal"]);
  }

  get hcpTotal() {
    return this.sumColsByNames(["hcpIndTotal", "hcpGrpTotal"]);
  }

  get hcpAverage() {
    return this.hcpTotal / this.hcpAmount;
  }

  get hcpIndAverage() {
    return this.hcpIndTotal / this.hcpIndAmount;
  }

  get hcpGrpAverage() {
    return this.hcpGrpTotal / this.hcpGrpAmount;
  }

  get hcoAmount() {
    return this.sumColsByNames(["hcoIndAmount", "hcoGrpAmount"]);
  }

  get hcoIndDonationTotal() {
    return this.hcoIndDonation;
  }

  get hcoGrpDonationTotal() {
    return this.hcoGrpDonation;
  }

  get hcoDonationTotal() {
    return this.sumColsByNames(["hcoIndDonationTotal", "hcoGrpDonationTotal"]);
  }

  get hcoIndEventTotal() {
    return this.sumColsByNames([
      "hcoIndRegCost",
      "hcoIndTravelCost",
      "hcoIndSponsorship"
    ]);
  }

  get hcoGrpEventTotal() {
    return this.sumColsByNames([
      "hcoGrpRegCost",
      "hcoGrpTravelCost",
      "hcoGrpSponsorship"
    ]);
  }

  get hcoRegTotal() {
    return this.sumColsByNames(["hcoIndRegCost", "hcoGrpRegCost"]);
  }

  get hcoTravelTotal() {
    return this.sumColsByNames(["hcoIndTravelCost", "hcoGrpTravelCost"]);
  }

  get hcoSponsorshipTotal() {
    return this.sumColsByNames(["hcoIndSponsorship", "hcoGrpSponsorship"]);
  }

  get hcoEventTotal() {
    return this.sumColsByNames([
      "hcoRegTotal",
      "hcoTravelTotal",
      "hcoSponsorshipTotal"
    ]);
  }

  get hcoIndSalaryTotal() {
    return this.sumColsByNames(["hcoIndBasicSalary", "hcoIndAdditionalSalary"]);
  }

  get hcoGrpSalaryTotal() {
    return this.sumColsByNames(["hcoGrpBasicSalary", "hcoGrpAdditionalSalary"]);
  }

  get hcoBasicSalaryTotal() {
    return this.sumColsByNames(["hcoIndBasicSalary", "hcoGrpBasicSalary"]);
  }

  get hcoAdditionalSalaryTotal() {
    return this.sumColsByNames([
      "hcoIndAdditionalSalary",
      "hcoGrpAdditionalSalary"
    ]);
  }

  get hcoSalaryTotal() {
    return this.sumColsByNames([
      "hcoBasicSalaryTotal",
      "hcoAdditionalSalaryTotal"
    ]);
  }

  get hcoIndTotal() {
    return this.sumColsByNames([
      "hcoIndDonationTotal",
      "hcoIndEventTotal",
      "hcoIndSalaryTotal"
    ]);
  }

  get hcoGrpTotal() {
    return this.sumColsByNames([
      "hcoGrpDonationTotal",
      "hcoGrpEventTotal",
      "hcoGrpSalaryTotal"
    ]);
  }

  get hcoTotal() {
    return this.sumColsByNames(["hcoIndTotal", "hcoGrpTotal"]);
  }

  get hcoAverage() {
    return this.hcoTotal / this.hcoAmount;
  }

  get hcoIndAverage() {
    return this.hcoIndTotal / this.hcoIndAmount;
  }

  get hcoGrpAverage() {
    return this.hcoGrpTotal / this.hcoGrpAmount;
  }

  get rndTotal() {
    return this.rndCost;
  }

  get total() {
    return this.sumColsByNames(["hcoTotal", "hcpTotal", "rndTotal"]);
  }

  get hcoSalaryPercent() {
    return this.hcoSalaryTotal / this.hcoTotal;
  }

  get hcoEventPercent() {
    return this.hcoEventTotal / this.hcoTotal;
  }

  get hcoDonationPercent() {
    return this.hcoDonationTotal / this.hcoTotal;
  }

  get hcoPercent() {
    return this.hcoTotal / this.total;
  }

  get hcoIndPercent() {
    return this.hcoIndTotal / this.hcoTotal;
  }

  get hcoGrpPercent() {
    return this.hcoGrpTotal / this.hcoTotal;
  }

  get hcoIndAmountPercent() {
    return this.hcoIndAmount / this.hcoAmount;
  }

  get hcoGrpAmountPercent() {
    return this.hcoGrpAmount / this.hcoAmount;
  }

  get hcpEventPercent() {
    return this.hcpEventTotal / this.hcpTotal;
  }

  get hcpSalaryPercent() {
    return this.hcpSalaryTotal / this.hcpTotal;
  }

  get hcpPercent() {
    return this.hcpTotal / this.total;
  }

  get hcpIndPercent() {
    return this.hcpIndTotal / this.hcpTotal;
  }

  get hcpGrpPercent() {
    return this.hcpGrpTotal / this.hcpTotal;
  }

  get hcpIndAmountPercent() {
    return this.hcpIndAmount / this.hcpAmount;
  }

  get hcpGrpAmountPercent() {
    return this.hcpGrpAmount / this.hcpAmount;
  }

  get rndPercent() {
    return this.rndTotal / this.total;
  }

  sumColsByNames(names: string[]) {
    let sum = 0;
    names.forEach((name: string) => {
      sum = sum + (this as any)[name];
    });
    return sum;
  }

  // sumColsByNames(names: string[], exclude: string[] = []): number {
  //   let cols = Object.getOwnPropertyNames(this);
  //   let sum = 0;
  //   cols = cols.filter(colName => {
  //     return (
  //       names.filter((partialName: string) =>
  //         colName.match(new RegExp(`${partialName}`))
  //       ).length === names.length
  //     );
  //   });
  //   cols = cols.filter(colName => {
  //     return !exclude.includes(colName);
  //   });
  //   cols.forEach((colName: any) => (sum += (this as any)[colName] || 0));
  //   return sum;
  // }

  // isOwner(user) {
  //   return isOwner(this, user);
  // }

  // canEdit(user) {
  //   return canEdit(this, user);
  // }

  // canView(user) {
  //   return canView(this, user);
  // }

  // canDelete(user) {
  //   return canDelete(this, user);
  // }

  // isClosed() {
  //   return isClosed(this);
  // }

  // isEvaluated() {
  //   return isEvaluated(this);
  // }

  // isApproved() {
  //   return isApproved(this);
  // }

  // canOpen(user) {
  //   return canOpen(this, user);
  // }

  // canClose(user) {
  //   return canClose(this, user);
  // }
}

export default ReportModel;

/*

get hcpRegCost(): number {
    return this.sumColsByNames(["hcp", "RegCost"]);
  }

  get hcpTravelCost(): number {
    return this.sumColsByNames(["hcp", "TravelCost"]);
  }

  get hcpBasicSalary(): number {
    return this.sumColsByNames(["hcp", "BasicSalary"]);
  }

  get hcpAdditionalSalary(): number {
    return this.sumColsByNames(["hcp", "AdditionalSalary"]);
  }

  get hcpIndTotal(): number {
    return this.sumColsByNames(["hcpInd"], ["hcpIndAmount"]);
  }

  get hcpGrpTotal(): number {
    return this.sumColsByNames(["hcpGrp"], ["hcpGrpAmount"]);
  }

  get hcpEventCost(): number {
    return this.hcpRegCost + this.hcpTravelCost;
  }

  get hcpSalaryCost(): number {
    return this.hcpBasicSalary + this.hcpAdditionalSalary;
  }

  get hcpTotal(): number {
    return this.hcpEventCost + this.hcpSalaryCost;
  }

  get hcoDonation(): number {
    return this.sumColsByNames(["hco", "Donation"]);
  }

  get hcoRegCost(): number {
    return this.sumColsByNames(["hco", "RegCost"]);
  }

  get hcoTravelCost(): number {
    return this.sumColsByNames(["hco", "TravelCost"]);
  }

  get hcoSponsorship(): number {
    return this.sumColsByNames(["hco", "Sponsorship"]);
  }

  get hcoBasicSalary(): number {
    return this.sumColsByNames(["hco", "BasicSalary"]);
  }

  get hcoAdditionalSalary(): number {
    return this.sumColsByNames(["hco", "AdditionalSalary"]);
  }

  get hcoIndTotal(): number {
    return this.sumColsByNames(["hcoInd"], ["hcoIndAmount"]);
  }

  get hcoGrpTotal(): number {
    return this.sumColsByNames(["hcoGrp"], ["hcoGrpAmount"]);
  }

  get hcoEventCost(): number {
    return this.hcoRegCost + this.hcoTravelCost + this.hcoSponsorship;
  }

  get hcoSalaryCost(): number {
    return this.hcoBasicSalary + this.hcoAdditionalSalary;
  }

  get hcoTotal(): number {
    return this.hcoDonation + this.hcoEventCost + this.hcoSalaryCost;
  }

  */
